import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BenefitsSection from "@/components/SellersPage/BenefitsSection.vue";
import ComparisonSection from "@/components/SellersPage/ComparisonSection.vue";
import FaqSection from "@/components/SellersPage/FaqSection.vue";
import ReviewsSection from "@/components/SellersPage/ReviewsSection.vue";
import SellerHero from "@/components/SellersPage/SellerHero.vue";
import StepsSection from "@/components/SellersPage/StepsSection.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SellersPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SellerHero),
    _createVNode(BenefitsSection),
    _createVNode(StepsSection),
    _createVNode(ComparisonSection),
    _createVNode(ReviewsSection),
    _createVNode(FaqSection)
  ], 64))
}
}

})